import React from "react";
import { Building2 } from "lucide-react";
import { Link } from "react-router-dom";

const Header = ({ minimal = false }) => {
  return (
    <header className="border-b border-slate-200 bg-white sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3" data-testid="logo-link">
          <div className="bg-primary rounded-lg p-2">
            <Building2 className="h-6 w-6 text-white" />
          </div>
          <span className="text-2xl font-bold text-primary">ECOPAY</span>
        </Link>
        {!minimal && (
          <nav className="hidden md:flex items-center gap-8">
            <a href="#fonctionnement" className="text-slate-600 hover:text-primary transition-colors">
              Fonctionnement
            </a>
            <a href="#avantages" className="text-slate-600 hover:text-primary transition-colors">
              Avantages
            </a>
            <Link 
              to="/connexion" 
              className="bg-primary text-white px-6 py-2 rounded-md hover:bg-primary/90 transition-all"
              data-testid="header-login-btn"
            >
              Se connecter
            </Link>
          </nav>
        )}
      </div>
    </header>
  );
};

export default Header;
